<script>
import BaseCheckbox from '@/components/_base-checkbox.vue'

export default {
  name: 'IncludeCheckboxes',
  components: {
    BaseCheckbox,
  },
  props: {
    include: {
      type: Object,
      required: true,
      default: () => ({
        active: false,
        cancelled: false,
        unapproved: false,
      }),
    },
  },
  emits: ['update:include'],
  computed: {
    localInclude: {
      get() {
        return this.include
      },
      set(val) {
        this.$emit('update:include', val)
      },
    },
  },
}
</script>

<template>
  <div>
    <label class="section-label">{{
      $t('exportBookings.include.label')
    }}</label>
    <div class="checkbox-group">
      <BaseCheckbox
        v-model="localInclude.active"
        sm
        @update:modelValue="localInclude = { ...localInclude, active: $event }"
      >
        <span class="checkbox-label">{{
          $t('exportBookings.include.active')
        }}</span>
      </BaseCheckbox>
      <BaseCheckbox
        v-model="localInclude.cancelled"
        sm
        @update:modelValue="
          localInclude = { ...localInclude, cancelled: $event }
        "
      >
        <span class="checkbox-label">{{
          $t('exportBookings.include.cancelled')
        }}</span>
      </BaseCheckbox>
      <BaseCheckbox
        v-model="localInclude.unapproved"
        sm
        @update:modelValue="
          localInclude = { ...localInclude, unapproved: $event }
        "
      >
        <span class="checkbox-label">{{
          $t('exportBookings.include.unapproved')
        }}</span>
      </BaseCheckbox>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-export.scss';
</style>
